import { createAction } from 'redux-actions';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { reduxKey } from './constants';
import { ResourceType } from '../../types/resource';
import { getRecipientForComment, getRecipientForDeviation } from '../utils';
export const pushAwardBadgeModal = (recipient, source, typeId, itemId, sectionname)=>pushModal(ModalType.AWARD_BADGE, {
        params: {
            recipient,
            source,
            typeId,
            itemId,
            sectionname
        },
        wrapInModal: false,
        biContext: sectionname ? {
            sectionname
        } : undefined
    });
export const beginDeviationAwardBadgeFlow = (deviation, source, sectionname = 'deviation')=>pushAwardBadgeModal(getRecipientForDeviation(deviation), source, ResourceType.DEVIATION, deviation.deviationId, sectionname);
export const beginCommentAwardBadgeFlow = (comment, source, sectionname = 'comment')=>pushAwardBadgeModal(getRecipientForComment(comment), source, ResourceType.COMMENT, comment.commentId, sectionname);
export const awardBadge = createAction(`${reduxKey}/AWARD`, (badgeType, recipient, source)=>({
        badgeType,
        recipient,
        source
    }));
export const awardingBadge = createAction(`${reduxKey}/AWARDING`, ()=>({}));
// This action creator looks different because Redux actions are only
// typed out to four arguments; any more and we need to collapse the args
export const awardBadgeSuccess = createAction(`${reduxKey}/AWARD.SUCCESS`, (payload)=>payload);
export const awardBadgeFail = createAction(`${reduxKey}/AWARD.FAIL`, (badgeType, recipient, source, errorMsg)=>({
        badgeType,
        recipient,
        source,
        errorMsg
    }));
export const fetchAvailableBadges = createAction(`${reduxKey}/FETCH_AVAILABLE_BADGES`, (userId, typeId, itemId)=>({
        userId,
        typeId,
        itemId
    }));
export const fetchAvailableBadgesSuccess = createAction(`${reduxKey}/FETCH_AVAILABLE_BADGES.SUCCESS`, (userId, results, gemRestrictions)=>({
        userId,
        results,
        gemRestrictions
    }));
export const fetchBadgeGiverStreamNext = createAction(`${reduxKey}/BADGE_GIVER_STREAM.FETCH_NEXT`, (streamId)=>({
        streamId
    }));

//# sourceMappingURL=actionCreators.js.map